/**
 * Get application version information
 * @returns {Object} Version information object
 */
export const getVersionInfo = () => {
    const version = process.env.REACT_APP_VERSION || require('../../package.json').version;
    const buildDate = process.env.REACT_APP_BUILD_DATE || new Date().toISOString();
    const commitHash = process.env.REACT_APP_COMMIT_HASH || 'dev';

    return {
        version,
        buildDate: new Date(buildDate),
        commitHash,
        fullVersion: `${version}+${commitHash.substring(0, 7)}`
    };
};

/**
 * Log version information to console
 */
export const logVersionInfo = () => {
    const info = getVersionInfo();
    console.log(`%c🧪 Wetlab LIMS Frontend`, 'font-size: 16px; font-weight: bold; color: #007bff;');
    console.log(`Version: ${info.version}`);
    console.log(`Build Date: ${info.buildDate.toLocaleString()}`);
    console.log(`Commit: ${info.commitHash.substring(0, 7)}`);
    return info;
};

// Make version info globally accessible in development
if (process.env.NODE_ENV === 'development') {
    window.getVersionInfo = getVersionInfo;
    window.logVersionInfo = logVersionInfo;
}
